// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"7552e69a","253":"dd4d8896","358":"6a7f93fc","420":"742080cf","603":"c8c05f9e","611":"7d05a218","787":"69520e74","869":"37d46539","897":"bfce1ad7","930":"23650af3"}[chunkId] + ".chunk.js";
};